/*
  Bild-Fallback (Luxusbetten24)

  Shopify liefert Produkt- und Dateibilder über die Shop-Domain (luxusbetten24.de/cdn/shop/…). Schlägt so ein Bild
  fehl (Safari zeigt dann ein blaues „?“ bzw. eine weiße Fläche), wird es genau einmal direkt über cdn.shopify.com
  nachgeladen – ohne srcset, in der Breite, die der Browser gerade gewählt hat. Gilt für alle <img> der Seite.
*/
(function () {
  var SHOP_PATH = '/cdn/shop/';
  var CDN_HOST = 'https://cdn.shopify.com/s/files/1/0416/8197/7495/';

  function fallbackUrl(src) {
    try {
      var u = new URL(src, location.href);
      var i = u.pathname.indexOf(SHOP_PATH);
      if (u.hostname === 'cdn.shopify.com' || i < 0) return null;
      // /cdn/shop/files/bild.jpg → https://cdn.shopify.com/s/files/1/…/files/bild.jpg (Query mit v= und width= bleibt)
      return CDN_HOST + u.pathname.slice(i + SHOP_PATH.length) + u.search;
    } catch (e) { return null; }
  }

  document.addEventListener('error', function (e) {
    var img = e.target;
    if (!img || img.tagName !== 'IMG' || img.dataset.cxRetried) return;
    var next = fallbackUrl(img.currentSrc || img.src);
    if (!next) return;
    img.dataset.cxRetried = '1';
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = next;
  }, true);
})();
